var _style, _circle, _defs, _g, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeaver45NewHover(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 105.1 155.1",
    style: {
      enableBackground: "new 0 0 105.1 155.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{clip-path:url(#SVGID_2_);}\r\n\t.st2{fill:#20140E;}\r\n\t.st3{fill:#422513;stroke:#20140E;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st4{fill:#E59625;stroke:#20140E;stroke-width:1.5;stroke-miterlimit:10;}\r\n\t.st5{fill:#1F1612;}\r\n\t.st6{fill:none;stroke:#20140E;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 67.1,
    cy: 39.2,
    r: 12.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -11.3,
    y: -6.3,
    width: 116.4,
    height: 168.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_19_",
    x: 51.5,
    y: 57.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -28.0422 65.777)",
    className: "st2",
    width: 27.8,
    height: 18.9
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_566_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_575_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_576_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_580_",
    className: "st3",
    d: "M74.6,16.8c0.8-1.4,1.2-3,1.2-4.7c0-5.4-4.4-9.7-9.7-9.7c-2.7,0-5.1,1.1-6.9,2.9 c-1.8,1.8-2.9,4.2-2.9,6.9c0,2.2,0.7,4.2,1.9,5.8c-5.1,1-10,2.7-14.5,5.1c-0.1-0.5-0.1-1-0.1-1.5s0-1.1,0-1.6 c0.7-8.4,6.1-17.8,6.1-17.8C41.2,7.4,35,13.5,30.3,19.8c-0.2-5.6,0.6-10.5,0.6-10.5c-11.2,14.2-14.4,29.1-14.7,41 c0,1.6,0,3.1,0,4.5c0.1,1.5,0.2,2.9,0.3,4.2c0,0.4,0,0.6,0,0.6c-1.6-1.2-3.6-1.9-5.8-1.9c-2.7,0-5.1,1.1-6.9,2.9 c-1.8,1.8-2.9,4.2-2.9,6.9c0,5.4,4.4,9.7,9.7,9.7c1.7,0,3.3-0.4,4.7-1.2c0.8,14,5.9,28.6,15,41.6c3,4.2,6.4,8.3,10.2,12.2 c7.5,7.5,15.9,13.4,24.7,17.6c6.9,3,10.2,4.1,14.9,5.5c9.9,2.9,20.1,3,29.4,1.3c2-0.4,3.8-1.4,5.2-2.7 c2.2-2.2,3.3-5.4,2.8-8.6c-1-6.3,0.9-13,5.8-17.9c4.9-4.9,11.6-6.8,17.9-5.8c3.3,0.5,6.4-0.6,8.6-2.8 c1.4-1.4,2.4-3.2,2.8-5.3c1.8-9.7,1.2-20.1-1.6-30.5c0,0,0,0,0,0.1c-0.4,1-0.9,2-1.6,2.9c-1.4,1.8-3.3,3.1-5.3,3.9l-0.2,0.1 h-0.1l0,0l0,0l-0.1,0.1l-0.4,0.1l-0.7,0.2c-0.2,0.1-0.6,0.1-0.9,0.2l-1,0.2h-0.9c-0.3,0-0.6,0-0.9,0 c-0.6-0.1-1.2-0.1-1.8-0.3c-0.3-0.1-0.6-0.1-0.8-0.2l-0.8-0.3l-0.4-0.2l-0.4-0.2l-0.7-0.4c-0.5-0.3-0.9-0.6-1.4-0.9 c-0.4-0.4-0.8-0.7-1.2-1.1c-1.5-1.5-2.8-3-3.9-4.7c-2.2-3.2-3.6-6.5-4.8-9.3c-1.1-2.8-1.9-5.2-2.4-6.9 c-0.5-1.7-0.7-2.7-0.7-2.7s0.4,0.9,1.1,2.5c0.7,1.6,1.8,3.8,3.2,6.5c0.7,1.3,1.5,2.7,2.4,4.1s1.9,2.9,3.1,4.3 c1.1,1.4,2.4,2.8,3.8,3.9c1.4,1.2,3,2,4.6,2.4c0.8,0.2,1.6,0.2,2.4,0.1c0.2,0,0.3-0.1,0.5-0.1s0.3,0,0.6-0.1l0.7-0.3l0.3-0.1 l0,0l0,0h0.1l0.1-0.1c1.6-0.7,2.9-1.7,3.8-2.9c0.5-0.6,0.8-1.2,1.1-1.9c0.2-0.7,0.4-1.4,0.5-2.1c0.2-1.4,0-2.9-0.2-4.3 s-0.6-2.6-1-3.7c-0.3-0.9-0.6-1.7-0.9-2.4c-4.2-8.8-10.1-17.2-17.6-24.7C112.7,26.4,93.2,17.8,74.6,16.8z M13.9,70.6 c-1.8,1.8-4.7,1.8-6.5,0s-1.8-4.7,0-6.5c1.8-1.8,4.7-1.8,6.5,0C15.7,65.9,15.7,68.8,13.9,70.6z M114,115.4 c-8,8-9.5,19.3-17.1,11.7c-7.7-7.7-9.2-22.1-1.3-30.1c7.9-7.9,22.4-6.4,30.1,1.3C133.3,105.9,122,107.4,114,115.4z  M69.3,15.3c-1.8,1.8-4.7,1.8-6.5,0s-1.8-4.7,0-6.5c1.8-1.8,4.7-1.8,6.5,0S71.1,13.5,69.3,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st2",
    d: "M75.1,67.1c-0.4,0.4-2.3,3.2-2.7,3.6c-0.4,0.4-0.7,0.8-1,1.2c-4.4,5.2-9.4,13.9-7,16.7 c2,2.1,9,5.5,11.5,6c4.6,1.2,12.6,0.2,16.1-3.7C95.6,87,96.3,80,95.2,75c-0.6-2.7-3.2-8-5-10C87.9,62.2,80,62.3,75.1,67.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_567_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_568_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_574_",
    className: "st4",
    d: "M95.6,97c-8,8-6.4,22.4,1.3,30.1s9.2-3.7,17.1-11.7c7.9-7.9,19.3-9.5,11.7-17.1 C118,90.6,103.6,89,95.6,97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_570_",
    className: "st4",
    d: "M7.4,64.2c-1.8,1.8-1.8,4.7,0,6.5s4.7,1.8,6.5,0s1.8-4.7,0-6.5 C12.1,62.4,9.2,62.4,7.4,64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_569_",
    className: "st4",
    d: "M62.8,8.8c-1.8,1.8-1.8,4.7,0,6.5s4.7,1.8,6.5,0s1.8-4.7,0-6.5S64.6,7,62.8,8.8z"
  }))))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.9,77.2c0.3-1.1,0.5-2.3,0.7-3.4l6.7,6.7c1.6,1.6,1.7,3.9,0.3,5.3l-3.7,3.7c-1,1-2.6,1.2-4,0.6 c-1.8-0.9-3.6-1.9-5.4-3.2C68,84,69.9,80.7,70.9,77.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.4,70.9c1.1-0.1,2.3-0.3,3.4-0.7c3.5-1,6.8-2.8,9.6-5.4c1.3,1.7,2.3,3.6,3.2,5.4c0.7,1.4,0.4,3-0.6,4 l-3.7,3.7c-1.4,1.4-3.7,1.2-5.3-0.3L74.4,70.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_577_",
    className: "st5",
    d: "M59.5,57.2c-0.3,0.3-0.6,0.5-0.9,0.8c-0.3,0.3-0.6,0.6-0.8,0.9c-3.6,3.9-5.9,8.4-3.9,10.5 c1.6,1.6,3.4,2.6,5.4,3c3.7,0.9,7.8-0.1,10.6-3c2.9-2.9,3.9-6.9,3-10.6c-0.5-2-1.5-3.9-3-5.4C68,51.2,63.4,53.6,59.5,57.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_571_",
    className: "st4",
    d: "M69.2,49.4c-0.9,0.1-1.6,0.3-2.4,0.5c-0.9,0.1-1.9,0.4-3,0.9C62,51.6,60,53,58.1,54.7 c-0.5,0.4-1,0.9-1.4,1.4c-0.5,0.5-0.9,1-1.4,1.4c-1.7,1.9-3,3.9-3.9,5.7c-0.5,1.1-0.8,2.1-0.9,3c-0.2,0.7-0.3,1.5-0.5,2.4 c-1.4,9.6-13.5,14.5-7.5,20.6c6,6,16.5,5.4,23.4-1.4l0,0c0.2-0.2,0.4-0.4,0.6-0.6c3.3-3.6,5-8,5-12.2c0,0-0.2-1.6,1.1-3 c1.5-1.2,3-1.1,3-1.1c4.2-0.1,8.6-1.8,12.2-5c0.2-0.2,0.4-0.4,0.6-0.6l0,0c6.8-6.9,7.5-17.3,1.4-23.4C83.8,35.8,78.8,47.9,69.2,49.4 z M73,58.7c0.9,3.7-0.1,7.8-3,10.6c-2.9,2.9-6.9,3.9-10.6,3c-2-0.5-3.9-1.5-5.4-3c-2.1-2.1,0.3-6.6,3.9-10.5 c0.3-0.3,0.5-0.6,0.8-0.9c0.3-0.3,0.6-0.6,0.9-0.8c3.9-3.6,8.4-5.9,10.5-3.9C71.6,54.8,72.6,56.7,73,58.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M74.6,34c-3.2-1.1-6.9-0.3-9.5,2.2c-2.6,2.6-3.3,6.3-2.2,9.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M45,63.6c-3.2-1.1-6.9-0.3-9.5,2.2c-2.6,2.6-3.3,6.3-2.2,9.5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeaver45NewHover);
export default __webpack_public_path__ + "static/media/beaver45new-hover.72ded4d5be81668b8ee5498c91de5309.svg";
export { ForwardRef as ReactComponent };